import type { ReturnRequestDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";

interface UseApproveOrRejectReturnParams {
	onSuccess: (returnRequest: ReturnRequestDto) => void;
}

interface ApproveOrRejectVariables {
	shopId: string;
	returnRequestId: string;
	status: "ok" | "rejected";
	/** Preset picked in the shop's disapproval reasons. Absent on a free text. */
	disapprovalReasonId?: string;
	/** Text shown to the merchant, sent as-is. The server re-resolves it from
	 * the preset only when it is left out. */
	disapprovalMessage?: string;
}

export default function useApproveOrRejectReturn(
	params: UseApproveOrRejectReturnParams,
) {
	return useApiMutation(
		"post",
		"/shops/{shopId}/return-requests/{returnRequestId}/approve-or-reject",
		{
			onSuccess: params.onSuccess,
			mapVariables: ({
				shopId,
				returnRequestId,
				...body
			}: ApproveOrRejectVariables) => ({
				params: {
					path: { shopId, returnRequestId },
				},
				body,
			}),
		},
	);
}
